<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisStaticMap from 'dashboard/components-next/LaisStaticMap.vue';

const props = defineProps({
  visit: { type: Object, default: () => ({}) },
  title: { type: String, default: 'Finalização pendente' },
  description: {
    type: String,
    default: 'Você precisa finalizar esta visita.',
  },
});

const property = computed(() => props.visit.imovel || {});
const clientName = computed(
  () => props.visit.contact?.name || props.visit.clientName || 'Cliente'
);
const propertyAddress = computed(
  () =>
    property.value.endereco ||
    property.value.address ||
    property.value.titulo ||
    props.visit.address ||
    'Endereço não informado'
);
const imageSrc = computed(
  () =>
    property.value.coverUrl ||
    property.value.cover_url ||
    property.value.thumbnailUrl ||
    property.value.thumbnail_url ||
    ''
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <article
    class="overflow-hidden rounded-lais border border-amber-200 bg-white text-[13px] text-amber-900 shadow-lais-card"
  >
    <div class="grid gap-3 p-4 sm:grid-cols-[96px,1fr]">
      <LaisStaticMap
        :src="imageSrc"
        :alt="property.titulo || 'Visita com finalização expirada'"
        aspect-class="aspect-[4/3]"
      />
      <div class="min-w-0">
        <span
          class="rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800"
        >
          Finalização expirada
        </span>
        <h3 class="mt-3 truncate text-[15px] font-semibold text-lais-text">
          {{ clientName }}
        </h3>
        <p class="mt-1 text-lais-text-body">{{ propertyAddress }}</p>
        <p class="mt-3 font-semibold">{{ title }}</p>
        <p class="mt-1">{{ description }}</p>
      </div>
    </div>
  </article>
</template>
